import { useQuery } from '@tanstack/react-query';
import { WalletConnector } from '../../interface/walet';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

interface UseGetWalletConnectorsProps {
  active?: boolean;
}

const getWalletConnectors = async ({ active }: UseGetWalletConnectorsProps) => {
  const { data } = await api.get<WalletConnectorResponse>(
    apiConfig.routes.wallet.connectors,
    { params: { active } }
  );
  return data;
};

export const useGetWalletConnectors = ({
  active = false,
}: UseGetWalletConnectorsProps = {}) => {
  return useQuery({
    queryKey: ['wallet', 'connectors', active],
    queryFn: () => getWalletConnectors({ active }),
  });
};

type WalletConnectorResponse = WalletConnector[];
